module.exports = __webpack_public_path__ + "static/Bhoomika_M-12256a6ef087efdbe59669d7fb688c87.jpeg";